'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Progress = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _throttle = require('lodash/throttle');

var _throttle2 = _interopRequireDefault(_throttle);

var _uncontrollable = require('uncontrollable');

var _uncontrollable2 = _interopRequireDefault(_uncontrollable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Progress = exports.Progress = function (_React$Component) {
  _inherits(Progress, _React$Component);

  function Progress(props) {
    _classCallCheck(this, Progress);

    var _this = _possibleConstructorReturn(this, (Progress.__proto__ || Object.getPrototypeOf(Progress)).call(this, props));

    _this.state = {
      actualPosition: props.position
    };
    _this.handleMouseMove = (0, _throttle2['default'])(_this.handleMouseMove.bind(_this), 100);
    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
    _this.handleMouseUp = _this.handleMouseUp.bind(_this);
    _this.setProgress = _this.setProgress.bind(_this);
    return _this;
  }

  _createClass(Progress, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        this.backdrop = document.createElement('div');
        Object.assign(this.backdrop.style, {
          display: 'none',
          position: 'fixed',
          width: '100%',
          height: '100%',
          top: '0',
          left: '0',
          cursor: 'pointer',
          zIndex: 10000
        });
        this.backdrop.style.display = 'none';
        this.backdrop.classList.add('onlinepbx__lib__progress__player--backdrop');
        document.body.appendChild(this.backdrop);

        this.viewport.onmousemove = this.handleMouseMove;
        this.viewport.onmousedown = this.handleMouseDown;
        this.viewport.onmouseup = this.handleMouseUp;
        this.backdrop.onmousemove = this.handleMouseMove;
        this.backdrop.onmousedown = this.handleMouseDown;
        this.backdrop.onmouseup = this.handleMouseUp;
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        document.body.removeChild(this.backdrop);
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'setProgress',
    value: function () {
      function setProgress(progress, fireEvent) {
        var _props = this.props,
            max = _props.max,
            min = _props.min,
            onChange = _props.onChange;

        var position = progress * (max - min) + min;
        this.setState({ actualPosition: progress * 100 });
        fireEvent && typeof onChange === 'function' && onChange(position);
      }

      return setProgress;
    }()
  }, {
    key: 'eventProgress',
    value: function () {
      function eventProgress(evt, viewport) {
        var rect = viewport.getBoundingClientRect();
        var isVertical = this.props.isVertical;
        var min = isVertical ? rect.bottom - rect.height : rect.left;
        var max = isVertical ? rect.bottom : rect.left + rect.width;
        var pos = Math.min(max, Math.max(min, isVertical ? evt.clientY : evt.clientX));
        if (isVertical) return 1 - (pos - min) / (max - min);
        return (pos - min) / (max - min);
      }

      return eventProgress;
    }()
  }, {
    key: 'handleMouseMove',
    value: function () {
      function handleMouseMove(evt) {
        if (!this.props.dragging && this.props.volume) return;
        this.props.onChangeDragging(true);
        this.setProgress(this.eventProgress(evt, this.viewport), this.props.immediate);
      }

      return handleMouseMove;
    }()
  }, {
    key: 'handleMouseDown',
    value: function () {
      function handleMouseDown(evt) {
        if (evt.button !== 0) return;
        this.props.onChangeDragging(true);
        this.setProgress(this.eventProgress(evt, this.viewport), this.props.immediate);
        this.backdrop.style.display = 'block';
        this.viewport.classList.add('onlinepbx__lib__progress__player--dragging');
        typeof this.props.onStartDragging === 'function' && this.props.onStartDragging();
      }

      return handleMouseDown;
    }()
  }, {
    key: 'handleMouseUp',
    value: function () {
      function handleMouseUp(evt) {
        this.backdrop.style.display = 'none';
        this.props.volume && this.props.onChangeDragging(false);
        this.viewport.classList.remove('onlinepbx__lib__progress__player--dragging');
        this.setProgress(this.eventProgress(evt, this.viewport), true);
        typeof this.props.onStopDragging === 'function' && this.props.onStopDragging();
      }

      return handleMouseUp;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _props2 = this.props,
            className = _props2.className,
            dragging = _props2.dragging,
            time = _props2.time,
            volume = _props2.volume,
            _props2$min = _props2.min,
            min = _props2$min === undefined ? 0 : _props2$min,
            _props2$max = _props2.max,
            max = _props2$max === undefined ? 100 : _props2$max,
            _props2$position = _props2.position,
            position = _props2$position === undefined ? 0 : _props2$position;

        var progress = (position - min) / (max - min);
        var circleX = dragging ? this.state.actualPosition : progress * 100;
        var lineX = progress * 100;
        return _react2['default'].createElement(
          'div',
          { className: (0, _classnames2['default'])('onlinepbx__lib__progress__wrapper', {
              'onlinepbx__lib__progress__wrapper__volume': volume
            }) },
          _react2['default'].createElement(
            'div',
            {
              className: (0, _classnames2['default'])('onlinepbx__lib__progress', className),
              ref: function () {
                function ref(node) {
                  return _this2.viewport = node;
                }

                return ref;
              }() // eslint-disable-line no-return-assign
            },
            _react2['default'].createElement('div', { className: 'onlinepbx__lib__progress__range__bg' }),
            _react2['default'].createElement('div', {
              style: { width: lineX + '%' },
              className: 'onlinepbx__lib__progress__range__line' })
          ),
          time && _react2['default'].createElement(
            'div',
            {
              className: 'onlinepbx__lib__progress__range__popup',
              style: { left: 'calc(' + String(circleX) + '% - 12px)' }
            },
            customFormatTime(circleX / 100 * time)
          )
        );
      }

      return render;
    }()
  }]);

  return Progress;
}(_react2['default'].Component);

function customFormatTime(timestamp) {
  var minutes = '' + Math.floor(timestamp / 60) || 0;
  var seconds = ('0' + String(Math.floor(timestamp - minutes * 60) || 0)).substr(-2);

  return String(minutes.length < 2 ? '0' + String(minutes) : minutes) + ':' + String(seconds);
}

exports['default'] = (0, _uncontrollable2['default'])(Progress, {
  dragging: 'onChangeDragging',
  position: 'onChange'
});